import { render, staticRenderFns } from "./RiskCheckDailySafetyLog.vue?vue&type=template&id=40e23938&scoped=true"
import script from "./RiskCheckDailySafetyLog.vue?vue&type=script&lang=js"
export * from "./RiskCheckDailySafetyLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e23938",
  null
  
)

export default component.exports